/**
 * Custom pagination: Implements infinite scrolling for collection pages.
 */
class CustomPagination extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false
    
    this.itemsContainer = this.querySelector(".custom-pagination-container");
    this.nextPageLink = this.querySelector(".custom-pagination-link");

    this.nextPageLink.addEventListener('click', this.loadNextPage.bind(this));

    this.observer = new IntersectionObserver(this.loadNextPage.bind(this), { rootMargin: '0px 0px 1000px 0px' })
    this.observer.observe(this.nextPageLink);
  }

  async loadNextPage(entries) {
    if (!entries[0].isIntersecting) return;

    if (this.isLoading) return;
    this.isLoading = true;
    this.nextPageLink.classList.add("custom-pagination-link--loading")

    try {
      // Load next page
      const response = await fetch(this.nextPageLink.href);
      if (!response.ok) throw new Error(response.status);

      const template = document.createElement('template');
      template.innerHTML = await response.text();

      // Parse and append fetched items
      let newItemsHtml = '';    
      template.content.querySelectorAll('custom-pagination .custom-pagination-item').forEach((result) => {
        newItemsHtml += result.outerHTML;
      });
      this.itemsContainer.insertAdjacentHTML('beforeend', newItemsHtml);

      // Update next page link
      const newNextPageLink = template.content.querySelector(".custom-pagination-link");
      if (newNextPageLink) {
        this.nextPageLink.href = newNextPageLink.href
      } else {
        this.nextPageLink.remove()
      }
    } catch (error) {
      console.log('Pagination: could not fetch next page - ', error);
    } finally {
      this.isLoading = false;
      this.nextPageLink.classList.remove("custom-pagination-link--loading")
    }
  }
}
customElements.define('custom-pagination', CustomPagination);


/**
 * Discount code: Component for copying a discount code to clipboard
 */
if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.discountCode = this.querySelector('.discount-code__code');
      this.discountCodeBtn = this.querySelector('.discount-code__btn');
      this.copySuccess = this.querySelector('.discount-code__success');
      this.init();
    }

    init() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        this.discountCodeBtn.addEventListener('click', this.copyCode.bind(this));
        this.discountCode.addEventListener('click', this.copyCode.bind(this));
      } else {
        this.discountCodeBtn.hidden = true;
      }
    }

    copyCode() {
      const discountCode = this.discountCode.dataset.discountCode.trim();
      navigator.clipboard.writeText(discountCode).then(
        () => {
          this.copySuccess.classList.remove('discount-code__success--hidden');
          
          this.copySuccess.animate(
            { opacity: [0, 1,], transform: ['translateY(-4px)', 'translateY(0)'] }, 
            { duration: 200, easing: "ease-out" }
          ); 

          setTimeout(() => {
            this.copySuccess.animate(
              { opacity: [1, 0], transform: ['translateY(0)', 'translateY(4px)'] }, 
              { duration: 200, easing: "ease-in" }
            ).finished.then(() => {
              this.copySuccess.classList.add("discount-code__success--hidden");
            }); 
          }, 2200);

        }
      );
    }
  }

  customElements.define('discount-code', DiscountCode);
}


/**
 * Video preloader: Custom preloader component for videos in product gallery and elsewhere.
 * 
 *  - Preloads the video once it gets close to view (on mobile gallery, once the user reaches the previous slide)
 *  - Simpler than the built in video-media component that caused issues on mobile.
 * 
 */
if (!customElements.get('video-preloader')) {
  class VideoPreloader extends HTMLElement {
    constructor(videoElement) {
      super();
      this.video = this.querySelector("video");
      this.carousel = this.closest("media-carousel");
      this.observer = null;
      this.loaded = false;
      this.init();
    }

    init() {
      // Preload the video once the user starts interacting with the carousel
      if (this.carousel) {
        this.carousel.addEventListener("carousel:change", event => {

          if (!this.loaded) {
            this.preloadVideo();
            this.loaded = true;
          }

        })
      }
    }

    preloadVideo() {
      this.video.setAttribute('preload', 'auto');
      this.video.load();
    }

    pause() {
      // Avoid auto play/pause from the carousel
    }

    play() {
      // Avoid auto play/pause from the carousel
    }
  }

  customElements.define('video-preloader', VideoPreloader);
}




